module.exports = __webpack_public_path__ + "img/0Q3A6289_L_WoodMatted.5c595d56.jpg";